<template>
  <div
    class="video-player"
    :style="{ height: height }"
    @click.stop="clickPlayer" @contextmenu.prevent>
    <video :src="mediaPath" :poster="videoCover"></video>
    <div class="play-btn-wrapper">
      <div v-show="!playing" class="play-btn" @click.stop="clickPlayBtn">
        <img src="../../../../../assets/image/play.png" />
      </div>
    </div>

    <div class="control-top">
      <!-- <div class="time">{{playTime}}/{{totalTime}}</div> -->
      <div class="screen-btn" @click.stop="fullScreen">
        <img src="../../../../../assets/image/full-screeb.png">
      </div>
    </div>

    <div class="control-bottom">
      <div class="control-bottom-container">
        <div class="progress-outer" @click="changePlayProgress">
          <div class="progress-inner" :style="{ width: `${progress}%` }"></div>
        </div>
        <div class="time">{{playTime}}/{{totalTime}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  requestFullScreen, exitFullScreen, isFullScreen, formatSecond,
} from '../../../../../utils';

export default {
  name: 'VideoPlayer',
  props: {
    mediaPath: { type: String, required: true },
    videoCover: { type: String, required: true },
    height: { type: String, default: '180px' },
  },
  data() {
    return {
      video: null,
      playing: false,
      duration: 0,
      currentTime: 0,
      jump: false,
    };
  },
  computed: {
    progress() {
      return (this.currentTime / this.duration) * 100;
    },
    totalTime() {
      return formatSecond(this.duration);
    },
    playTime() {
      return formatSecond(this.currentTime);
    },
  },
  methods: {
    clickPlayer() {
      if (!this.video) {
        this.video = this.$el.querySelector('video');
      }

      if (!this.video.paused) {
        this.video.pause();
        this.playing = false;
      }
    },
    clickPlayBtn() {
      if (!this.video) {
        this.video = this.$el.querySelector('video');
      }

      if (this.video.paused) {
        this.video.play();
        this.playing = true;
      }
    },
    changePlayProgress({ offsetX, currentTarget }) {
      this.jump = true;
      this.video.currentTime = offsetX / currentTarget.clientWidth * this.duration;
    },
    fullScreen() {
      if (isFullScreen()) {
        exitFullScreen(this.$el);
      } else {
        requestFullScreen(this.$el);
      }
    },
  },
  mounted() {
    this.video = this.$el.querySelector('video');

    this.video.addEventListener('loadeddata', ({ target }) => {
      this.duration = target.duration;
    });

    this.video.addEventListener('timeupdate', ({ target }) => {
      this.currentTime = target.currentTime;

      if (this.jump && this.video.paused) {
        this.video.play();
        this.playing = true;
        this.jump = false;
      }

      if (!this.playing) {
        this.playing = true;
      }
    });

    this.video.addEventListener('pause', () => {
      this.playing = false;
    });
  },
};
</script>

<style lang="less" scoped>
.video-player {
  position: relative;
  display: inline-block;
  overflow: hidden;
  text-align: center;
  width: 100%;
  height: 100%;

  &:hover {
    .control-top {
      transform: translateY(0);
    }

    .control-bottom {
      transform: translateY(0);
    }
  }

  > video {
    max-width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .play-btn-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;

    > .play-btn {
      cursor: pointer;
      width: 56px;
      height: 56px;
      pointer-events: visible;
      background-color: rgba(0, 0, 0, .12);
      border-radius: 50%;

      > img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .control-top {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    padding: 0 8px;
    height: 32px;
    background-image: linear-gradient(
        to bottom,
      rgba(0, 0, 0, .36) 42%,
      rgba(0, 0, 0, 0.16) 82%,
      rgba(0, 0, 0, 0) 100%);
    transform: translateY(-100%);
    transition: all ease-in .2s;

    .screen-btn {
      width: 22px;
      height: 22px;
      cursor: pointer;

      > img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .control-bottom {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 0 8px;
    height: 32px;
    background-image: linear-gradient(
        to top,
      rgba(0, 0, 0, .36) 42%,
      rgba(145, 57, 57, 0.16) 82%,
      rgba(0, 0, 0, 0) 100%);
    transform: translateY(100%);
    transition: all ease-in .2s;

    &-container {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 100%;

      .time {
        margin-left: 12px;
        display: inline-block;
        font-size: 12px;
        color: #fff;
        // padding: 2px 6px;
        // background-color: rgba(0, 0, 0, 0.26);
        // border-radius: 4px;
      }
    }

    .progress-outer {
      flex: 1;
      position: relative;
      height: 3px;
      border-radius: 4px;
      background-color: hsla(0, 0%, 100%, 0.2);
      cursor: pointer;

      > .progress-inner {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        background-color: rgba(12, 140, 202, 1);
        transition: all .32s linear;
      }
    }
  }
}
</style>
